import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage, FormattedDate } from "react-intl";

import AlmigButton from "../grundelemente/AlmigButton";
import DisabledOverlay from "../grundelemente/DisabledOverlay";
import InfoBlock from "../grundelemente/InfoBlock";
import InfoDateContainer from "../grundelemente/InfoDateContainer";
import InfoEmpty from "../grundelemente/InfoEmpty";
import InfoPanel from "../grundelemente/InfoPanel";

// bei dem "UTC" bin ich mir nicht 100%ig sicher, aber im test siehts gerade richtig aus
const ThinkGreenDatum = props => (
	<FormattedDate value={props.timespan[props.date_field] * 1000}
		timeZone="UTC"
		year="numeric" month="2-digit" day="2-digit"
		hour="2-digit" minute="2-digit"/>
);

ThinkGreenDatum.propTypes = {
	timespan: PropTypes.object.isRequired,
	date_field: PropTypes.string.isRequired
};

const ThinkGreenInfoPanel = props => (
	<InfoPanel>
		<InfoBlock>
			<FormattedMessage id="From" /><br />
			<ThinkGreenDatum timespan={props.think_green} settings={props.settings} date_field="time_of_first_update" /><br />
			<FormattedMessage id="Until" /><br />
			<ThinkGreenDatum timespan={props.think_green} settings={props.settings} date_field="time_of_last_update" />
		</InfoBlock>
		<InfoBlock>
			<DisabledOverlay disabled={!props.auth.canWrite} />
			<AlmigButton i18n_key="Reset" onClick={props.doReset} />
		</InfoBlock>
		<InfoEmpty height="200px" />
		<InfoDateContainer />
	</InfoPanel>
);

ThinkGreenInfoPanel.propTypes = {
	think_green: PropTypes.object.isRequired,
	settings: PropTypes.object.isRequired,
	doReset: PropTypes.func.isRequired,
	auth: PropTypes.object.isRequired
};

export default ThinkGreenInfoPanel;
